import AccountService from './accountService';
import AccountService2 from './accountService2';
import axios from './axiosConfig';
import CallService from './callService';
import CallService2 from './callService2';
import LoginService from './loginService';
import MeetService from './meetService';
import ScheduleService from './scheduleService';
import UserService from './userService';

const userService = new UserService(axios);
const accountService = new AccountService(axios);
const loginService = new LoginService(axios);
const scheduleService = new ScheduleService(axios);
const callService = new CallService(axios);
const meetService = new MeetService(axios);
const callService2 = new CallService2(axios);
const accountService2 = new AccountService2(axios);

export {
    userService,
    accountService,
    loginService,
    scheduleService,
    callService,
    meetService,
    callService2,
    accountService2
};
